import { render } from 'react-dom';
// eslint-disable-next-line import/no-unresolved
import './style.sass';

import Main from './Main';

declare global {
   interface Window {
      DatoCmsPlugin: any;
   }
}

window.DatoCmsPlugin.init((plugin) => {
   plugin.startAutoResizer();

   const container = document.createElement('div');
   document.body.appendChild(container);

   render(<Main plugin={plugin} />, container);
});
